import templateUrl from './detectorV2Rule.tpl.html';
import { NEW_ALERTS_INVENTORY_TIME_RANGE_PARAMS } from '../../alerts/overview/alertsInventoryUrlParams';

angular.module('signalview.detectorV2').directive('v2DetectorRule', [
    'ALERT_SEVERITY_LEVELS',
    'v2DetectorWizardModal',
    'moment',
    'featureEnabled',
    function (ALERT_SEVERITY_LEVELS, v2DetectorWizardModal, moment, featureEnabled) {
        return {
            restrict: 'E',
            templateUrl,
            scope: {
                rule: '=',
                isNewRule: '=',
                labels: '=?',
                reassign: '=?',
                alertCount: '=',
                detector: '=?',
                openSignalflowTab: '=',
                model: '=?',
                hasWritePermission: '<?',
                onToggleRule: '&',
                isSelected: '<?',
                fetchActiveAlerts: '&fetchActiveAlerts',
            },
            link: function ($scope) {
                $scope.severityLevels = ALERT_SEVERITY_LEVELS;
                $scope.edit = edit;

                const isNewRule = !$scope.detector.rules.some(
                    (rule) => rule.detectLabel === $scope.rule.detectLabel
                );

                $scope.isLoadingAlertsCount = () => $scope.alertCount?.isLoading === true;
                $scope.isAlertsCountUnknown = () =>
                    typeof $scope.alertCount?.count !== 'number' && !isNewRule;
                $scope.getAlertsHref = function () {
                    const detectorId =
                        $scope.detector?.id || $scope.detector?.sf_id || $scope.model?.sf_id;
                    const severity = $scope.rule.severity;
                    if (featureEnabled('newAlertsInventoryPage')) {
                        return (
                            '#/alerts?detectorIds=' +
                            encodeURIComponent(detectorId) +
                            '&severity=' +
                            encodeURIComponent(severity) +
                            '&' +
                            NEW_ALERTS_INVENTORY_TIME_RANGE_PARAMS
                        );
                    }
                    return (
                        '#/alerts?sources[]=sf_detectorId:' +
                        encodeURIComponent(detectorId) +
                        '&sources[]=sf_severity:' +
                        severity
                    );
                };
                $scope.activeAlertsOutdated = () => $scope.alertCount?.outdated === true;
                $scope.getTooltipText = () => {
                    let text = 'Active alerts for this rule';
                    if ($scope.alertCount?.timestamp) {
                        text += ` (last refresh: ${moment($scope.alertCount.timestamp).format(
                            'HH:mm:ss'
                        )})`;
                    }
                    return text;
                };

                function edit() {
                    v2DetectorWizardModal.editRule(
                        $scope.detector,
                        $scope.rule,
                        $scope.isNewRule,
                        $scope.model,
                        $scope.hasWritePermission
                    );
                }
            },
        };
    },
]);
